import React from "react";
import { Card, CardBody } from "reactstrap";
import { Formik, Form, Field } from "formik";

const LangeVerzoeken = ({ data, handleFieldChange }) => {
    return (
        <Card className="main-card">
            <CardBody className="d-flex flex-column mb-4">
                <div className="btn-color-style travelCost-blue-text mb-4">Lange verzoeken</div>

                <Formik
                    enableReinitialize
                    initialValues={{
                        eHasProlongedApp: data?.eHasProlongedApp === "Y",
                    }}
                >
                    {({ values, setFieldValue, setFieldError }) => (
                        <Form>
                            <div className="d-flex justify-content-between custom-switch">
                                <div style={{ width: "60%" }}>
                                    Lange verzoeken inschakelen
                                </div>
                                <div style={{ width: "40%" }}>
                                    <label className="switch">
                                        <Field
                                            type="checkbox"
                                            name="eHasProlongedApp"
                                            checked={values.eHasProlongedApp}
                                            onChange={(e) => {
                                                setFieldValue(
                                                    "eHasProlongedApp",
                                                    e.target.checked
                                                );
                                                handleFieldChange(
                                                    "eHasProlongedApp",
                                                    e.target.checked ? "Y" : "N", setFieldError
                                                );
                                            }}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </CardBody>
        </Card>
    );
};

export default LangeVerzoeken;
